module.exports = __webpack_public_path__ + "images/blue-image-one.png";